<template>
    <editing-sub-frame :sub_type="sub_type" :sub_code="sub_code" :sub_guide="sub_data_contents_information">
        <template #head>
            <!--제목, 컴포넌트 기본 공통 -->
            
            <!--     label이 있는 경우에만 폼 활성화        -->
            <template v-if="label">
                <div class="mt-3 mb-1 fw-600 f-90"> Sub label *</div>
                <b-form-input v-model="sub_label" placeholder="필수 입력" />    
            </template>
            
            <div class="mt-3 mb-1 fw-600 f-90"> Sub type </div>
            <div class="d-flex justify-content-between">
                <b-dropdown :text="sub_type" variant="dark-border" class="mr-2">
                    <b-dropdown-item-button v-for="(sub_type, sub_type_idx) in sub_types"
                        :key="`subs-table-subtype-opt-${sub_type}-${sub_type_idx}`"
                        @click="selectType(sub_type)"
                        >
                        {{ sub_type }}
                    </b-dropdown-item-button>
                </b-dropdown>
                <b-form-input v-model="sub_name" placeholder="Title (필요시 작성)" > {{ sub_name }} </b-form-input>
            </div>

            <div class="mt-3 mb-1 fw-600 f-90">Description</div>
            <b-textarea v-model="sub_description" placeholder="A1. ㅇㅇㅇ을 관리하고 있습니까?" />

            <div class="mt-3 mb-1 fw-600 f-90">Info</div>
            <b-textarea v-model="sub_info" placeholder="용어설명, 참고사항, 평가기준 등 답변 참고정보" />
        </template>

        <!-- <div class="mt-3 mb-1 fw-600 f-90" style="cursor:pointer" @click="conditionPopoverToggle()">Condition <fa :id="`sub_condition_information+${sub_code}`" icon="info-circle"></fa></div>
            <b-popover :target="`sub_condition_information+${sub_code}`" title="설명" :content="sub_condition_information" placement="left" :show="sub_condition_popover_show">
            </b-popover>
        <div  id="editing-template-condition">
            <b-form-checkbox v-model="is_condition_available" @input="manageConditionAvailability()" class="editing-dfs">
                <b-form-input placeholder="선행조건 표시내용을 입력해 주세요" v-model="sub_condition.text"> {{ sub_condition.text }} </b-form-input>
            </b-form-checkbox>      
        </div> -->

        <template #structure>
            <div class="mb-3">
                <div class="fw-600 f-90 mb-1">Table Header </div>  
                <b-form-input v-model="table_header" placeholder="ex. 구분, 항목A, 항목B">
                    {{ table_header }}
                </b-form-input>
            </div>
            
            <!-- DF Table 데이터 구조 수정 -->
            <div class="fw-600 f-90 mb-1"> Table Contents </div>
            <b-card no-body class="border-top-0 border-bottom-0 mb-2">
                <b-table-simple class="mb-0" bordered hover>
                    <b-tbody>
                        <b-tr>
                            <b-th class="bgray-100"></b-th>
                            <b-th v-for="(col_item, col_idx) in table_header_col" :key="`subs-table-header-col-${col_idx}`"
                                class="bgray-100"
                                >
                                {{ col_item }}
                            </b-th>
                            <b-th class="bgray-100"></b-th>
                        </b-tr>
                        <b-tr v-for="(row_item, row_index) in sub_data_contents.structure"
                            :key="`subs-table-body-row-${row_index}`"
                            >
                            <b-td> {{ row_index + 1 }} </b-td>
                            <b-td v-for="(col_item, col_index) in table_header_col"
                                :key="`subs-table-body-row-${row_index}-col-${col_index}`"
                                >
                                <div @click="editCell(row_index, col_index)"> 
                                    <!-- 필수 셀 표시 (structure[row].required_cells) -->
                                    <div v-if="row_item.required_cells && row_item.required_cells.includes(col_item)"
                                        class="red f-80 fw-500"
                                        >
                                        * 필수
                                    </div>
                                    <template v-if="row_item.noteditables && row_item.noteditables.includes(col_item)">
                                        <div v-html="row_item[col_item]"></div>
                                    </template>
                                    <template v-else-if="row_item.dropdown && row_item.dropdown[col_item]">
                                        <b-dropdown :id="`dropdown-${sub_code}-${row_index}-${col_index}`"
                                            :text="row_item[col_item]"
                                            >
                                            <b-dropdown-item v-for="drop_item in row_item.dropdown[col_item]"
                                                :key="drop_item.id"
                                                >
                                                {{ drop_item }}
                                            </b-dropdown-item>
                                        </b-dropdown>
                                    </template>
                                    <template v-else-if="row_item.calculation && row_item.calculation[col_item]">
                                        ( {{ row_item.calculation[col_item] }} )
                                    </template>
                                    <template v-else> 
                                        <b-form-input v-model="row_item[col_item]"
                                            :type="(row_item.input_type && row_item.input_type[col_item]) || 'text'"
                                            :readonly="true"
                                            :placeholder="row_item.placeholder && row_item.placeholder[col_item]"
                                            />
                                    </template>
                                </div>
                            </b-td>
                            <b-td>
                                <b-btn variant="icon" size="sm"
                                    @click="addDuplicatedRow(row_index)"
                                    >
                                    복제
                                </b-btn>
                                <b-btn variant="icon" size="sm"
                                    @click="deleteRow(row_index)"
                                    >
                                    삭제
                                </b-btn>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-card>

            <b-alert :show="is_any_cell_enough" variant="info" class="py-2 f-85">
                필수 셀을 지정하지 않으면 표에 값이 하나라도 있으면 통과합니다. 특정 칸을 강제하려면 그 셀에 필수를 지정하세요.
            </b-alert>

            <!-- 셀 에디터 모달 -->
            <template v-if="editing_row">
                <b-modal title="테이블 셀 설정"
                    :id="`table-cell-editor-${sub_code}`"
                    :ref="`table-cell-editor-${sub_code}`"
                    @ok="handleCellEditorOK($event)"
                    @hidden="initializeCellEditorOption"
                    >
            
                    <b-form-select v-model="option_cell_selected" class="mb-3">
                        <option value="input_text">텍스트 입력 폼</option> 
                        <option value="dropdown">드롭다운 선택지</option> 
                        <option value="text">수정불가 텍스트</option>
                        <option value="calculation">계산식</option>
                    </b-form-select>

                    <!-- 필수 셀: 협력사가 반드시 채워야 하는 셀. 수정불가 텍스트·계산식 셀은 판정 대상이 아니라 선택 불가 -->
                    <b-form-checkbox v-if="['input_text', 'dropdown'].includes(option_cell_selected)"
                        v-model="required_cell"
                        class="mb-3"
                        >
                        필수 셀 (미답변 제출 차단 옵션이 켜진 캠페인에서 이 셀이 비어 있으면 제출 불가)
                    </b-form-checkbox>

                    <b-alert :show="required_cell && is_submit_required_off" variant="warning" class="py-2 f-85">
                        문항의 '답변 필수 여부' 가 끔(면제)으로 설정돼 있어 이 셀 지정은 적용되지 않습니다.
                    </b-alert>
                    
                    <!-- 텍스트 입력 폼일 경우 -->
                    <template v-if="option_cell_selected == 'input_text'">
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            기본 값
                            <b-form-input v-model="input_form.default_value"
                                placeholder="미리 입력될 기본 값을 입력해주세요"
                                class="w-75"
                                />
                        </div>
                        <div class="d-flex justify-content-between align-items-center mb-2">
                            입력값 유형
                            <b-form-select v-model="input_form.type_value"
                                :options="cell_types"
                                class="w-75"
                                />
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                            가이드텍스트
                            <b-form-input v-model="input_form.placeholder"
                                placeholder="입력 가이드를 입력해주세요"
                                class="w-75"
                                />
                        </div>
                    </template>

                    <!-- 드롭다운 선택지일 경우 -->
                    <template v-else-if="option_cell_selected=='dropdown'">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            선택지
                            <b-form-input v-model="dropdown.text" class="w-75"
                                placeholder="선택지 항목을 쉼표로 구분하여 입력해주세요"
                                >
                            </b-form-input>
                        </div>
                        <b-card>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="text-nowrap f-90 mr-2">미선택시 기본 값:</div>
                                <b-form-input v-model="dropdown.default_value"
                                    size="sm" placeholder="기본값을 입력해 주세요"
                                    />
                            </div>
                        </b-card>
                    </template>

                    <!-- 수정불가 텍스트일 경우 -->
                    <template v-if="option_cell_selected=='text'">
                        <div class="editing-dfs">
                            표시 텍스트
                            <b-form-input v-model="noteditable_label"
                                placeholder="셀에 직접 표시될 내용을 입력해 주세요"
                                />
                        </div>
                    </template>

                    <!-- 계산식일 경우 -->
                    <template v-if="option_cell_selected=='calculation'">
                        <div>
                            계산식
                            <b-form-input v-model="calculation.string"
                                :state="calculation.status"
                                placeholder="계산식을 입력해 주세요(ex. A1+B1)"
                                >
                                {{ calculation.string }}
                            </b-form-input>
                            {{ calculation.status_message }}
                        </div>
                    </template>
                </b-modal>
            </template>

            <div class="text-right">
                <b-btn size="sm" variant="info" @click="addNewTableRow">새 행 추가</b-btn>
            </div>
        </template>
        
        <template #option>
            <!-- Tags, Child 등 기본 공통 -->
            <b-list-group>
                <b-list-group-item>
                    <editing-sub-submit-required v-model="submit_required" :sub_code="sub_code" />
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부문항"
                        :label-for="`editing-subs-table-${sub_code}-has_attachment`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-table-${sub_code}-has_attachment`"
                            v-model="has_attachment"
                            >
                            파일 및 URL 첨부
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>
                
                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="첨부필수"
                        :label-for="`editing-subs-table-${sub_code}-required_attachment`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-table-${sub_code}-required_attachment`"
                            v-model="required_attachment"
                            :disabled="!has_attachment"
                            >
                            첨부필수 문항
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="필수답변"
                        :label-for="`editing-subs-radio-${sub_code}-required_answer`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-radio-${sub_code}-required_answer`"
                            v-model="required_answer"
                            >
                            필수답변
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Risk"
                        :label-for="`editing-subs-table-${sub_code}-risk`"
                        class="align-items-center mb-0"
                        >
                        <b-form-checkbox :id="`editing-subs-table-${sub_code}-risk`"
                            v-model="sub_risk"
                            >
                            적용
                        </b-form-checkbox>
                    </b-form-group>
                </b-list-group-item>

                <b-list-group-item>
                    <b-form-group
                        label-cols="12"
                        label-cols-md="4"
                        label-cols-xl="2"
                        content-cols="12"
                        content-cols-md="8"
                        content-cols-xl="9"
                        label="Tags"
                        :label-for="`editing-subs-table-${sub_code}-tags`"
                        class="align-items-center mb-0"
                        >
                        <b-input :id="`editing-subs-table-${sub_code}-tags`" v-model="tags"
                            placeholder="띄어쓰기 대신 _ 사용, 쉼표로 구분"
                            />
                    </b-form-group>
                </b-list-group-item>
            </b-list-group>
        </template>

        <template #footer>
            <div class="text-right">
                <b-button variant="blue" class="mr-2"
                    @click="handleSaveSub"
                    :disabled="is_saving_subs"
                    >
                    <div class="d-flex align-items-center">
                        저장 <b-spinner v-show="is_saving_subs" small class="ml-2" />
                    </div>
                </b-button>
                <b-button @click.stop="$emit('click-cancel')" variant="dark">취소</b-button>
            </div>
        </template>
    </editing-sub-frame>
</template>

<script>
import { EditingSubComponentMixin } from '@core_mixins/EditingSubComponentMixin'
import * as ih from '@core_utils/util'
const {
    SUBMIT_REQUIRED_OFF,
    SUBMIT_REQUIRED_ON,
    hasRequiredCells,
    promoteSubmitRequiredForCell
} = require('@core/mixins/submit-required-override.cjs')

export default {
    name: 'editing-df-table',
    mixins: [EditingSubComponentMixin],
    data() {
        return {
            sub_data_header_information: `
                { "테이블 헤더 항목을 쉼표로 구분하여 입력해 주세요. (ex. 구분, 이름, 직책, 비고)" }
            `,
            sub_data_contents_information: `
                행 추가/복사: 행을 추가하거나 복사할 수 있습니다.
                각 셀의 설정을 변경하려면 셀을 클릭하십시오. 
                각 셀 별로 텍스트 입력 폼, 드롭다운, 수정불가 텍스트 중 선택할 수 있습니다. 
            `,
            // 기본값은 최소 한 컬럼만. 연도를 박아두면 해가 바뀔 때마다 손대야 하는데,
            // 헤더를 고치면 번역 정합성 가드에 걸려 저장이 막힌다.
            table_header: '구분',
            row_initial_property: {
                placeholder: {}, input_type: {},
                noteditables: [], dropdown: {},
                calculation: {}
            },
            cell_types: [
                { value: 'text', text: '텍스트' },
                { value: 'number', text: '숫자' },
                { value: 'date', text: '날짜' },
            ],

            editing_row: null,
            editing_row_index: 0,
            editing_col_index: 0,
            editing_col_label: 0,
            option_cell_selected: null,

            input_form: {
                default_value: null,
                type_value: 'text',
                placeholder: null
            },
            
            dropdown: {
                text: null,
                options: null,
                default_value: null
            },

            noteditable_label: null,
            required_cell: false,

            calculation: {
                string: null,
                validated_str: null,
                status: null,
                status_message: null
            },
            
            sub_condition_string: '',
            sub_data_header_string: '',
            sub_data_contents_string: '',
            
            calculation_string: '',
            calculation_validated_str: '',
            calculation_status: false,
            calculation_status_message: ''

            
            // `[{ "No": "1", "이름": "홍길동", "독립성": "", "직업": "모름",
            //      "noteditables": ["No", "이름"],
            //      "dropdown": { "독립성": ["독립","비독립"] },
            //      "placeholders": { "독립성": "독립성 여부를 입력해 주세요" }
            //      },
            // { "No": "2", "이름": "누구", "독립성": "비독립", "직업": "모름" }]`
        }
    },
    computed: {
        // 문항이 '끔' 이면 셀 지정이 무의미하다는 것을 셀 모달에서 알린다
        is_submit_required_off () {
            return this.submit_required === SUBMIT_REQUIRED_OFF
        },
        // '켬' 인데 지정된 필수 셀이 하나도 없으면 값이 하나라도 있으면 통과한다 (칸 단위 강제는 셀 지정으로)
        is_any_cell_enough () {
            return this.submit_required === SUBMIT_REQUIRED_ON
                && !hasRequiredCells(this.sub_data_contents && this.sub_data_contents.structure)
        },
        table_header_col: {
            get() {
                return ih.stringToArray(this.table_header)
            }
        }
    },
    watch: {
        sub_data_contents: {
            immediate: true,
            handler (newValue) {
                if(newValue && newValue.table_header) {
                    this.table_header = ih.arrayToString(newValue.table_header)
                }
            }
        },
        'input_form.type_value': {
            handler (_selected_type) {
                if (_selected_type === 'number') {
                    if (isNaN(Number(this.input_form.default_value))) {
                        this.input_form.default_value = null
                    }
                }
                
            }
        },
        'calculation.string': {
            handler(newValue) {
                this.calculation.status_message = '산식을 판단 중입니다'
                this.calculation.status = false 
                this.calculation.validated_str = ''

                let validated_str = newValue

                validated_str.replace(/[\{\}\[\]?.,;:|~`!^\_<>@\#$%&\\\=\'\"\s]/gi,'')

                let var_items = validated_str.match(/([A-Z0-9\(\)]+)/gi)
                let calculation_items = validated_str.match(/([+-/*])/g)

                if(var_items == null) var_items = []
                if(calculation_items == null) calculation_items = []

                if(!var_items[0]) {
                    this.calculation.status_message = '산식은 셀 참조(ex.A1), 괄호 또는 숫자로 시작해야 합니다'
                    //this.calculation_status_message = 'var_items' + var_items + ' calculation_items:' + calculation_items
                    this.calculation.status = false
                }
                else if(var_items.length != calculation_items.length + 1) {
                    this.calculation.status_message = '산식이 연산자로 끝나거나, 셀 참조(ex.A1)와 연산자(ex.+) 구성이 적절하지 않습니다'
                    //this.calculation_status_message = 'var_items:' + var_items + ' calculation_items:' + calculation_items
                    this.calculation_status = false
                }
                else {
                    this.calculation.validated_str = validated_str
                    this.calculation.status_message = '적절한 산식입니다'
                    this.calculation.status = true
                }
            }
        }

    },
    created () {
        if (!this.sub_data_contents.structure.length) {
            this.sub_data_contents.structure.push({ ...this.row_initial_property })
        }
    },
    methods: {
        editCell(row_index, col_index) {
            let _row = JSON.parse(JSON.stringify(this.sub_data_contents.structure[row_index]))
            let _col = this.table_header_col[col_index]
            
            // 순차적으로 판단하여 현재 셀이 input_text인지, dropdown인지, noteditable text인지, calculation인지 구분하여 초기화
            this.option_cell_selected = 'input_text'
            if (_row.dropdown && _row.dropdown[_col]) {
                this.option_cell_selected = 'dropdown'
                this.dropdown = {
                    text: ih.arrayToString(_row.dropdown[_col]),
                    options: _row.dropdown[_col],
                    default_value: _row[_col]
                }
            } else { 
                this.dropdown = { text: null, options: null, default_value: null }
            }

            if (_row.calculation && _row.calculation[_col]) {
                this.option_cell_selected = 'calculation'
                this.calculation.string = _row.calculation[_col]
            } else {
                this.calculation = {
                    string: null, validated_str: null, status: null, status_message: null
                }
            }
            
            if (_row.noteditables && _row.noteditables.includes(_col)) {
                this.option_cell_selected = 'text'
                this.noteditable_label = _row[_col]
            } else {
                this.noteditable_label = null
            }

            this.required_cell = !!(_row.required_cells && _row.required_cells.includes(_col))

            if (this.option_cell_selected === 'input_text') {
                this.input_form = {
                    default_value: _row[_col] || null,
                    type_value: (_row['input_type'] && _row['input_type'][_col]) || null,
                    placeholder: (_row['placeholder'] && _row['placeholder'][_col]) || null
                }
            } else {
                this.input_form = { default_value: null, type_value: 'text', placeholder: null }
            }

            this.editing_row_index = row_index
            this.editing_col_index = col_index
            this.editing_col_label = _col
            this.editing_row = JSON.parse(JSON.stringify(_row))

            this.$nextTick(() => {
                this.$bvModal.show(`table-cell-editor-${this.sub_code}`)
            })
        },
        handleCellEditorOK(bvModalEvt, row_index = this.editing_row_index, col_index = this.editing_col_index) {
            let _row = this.editing_row
            let _col = this.table_header_col[col_index]

            bvModalEvt.preventDefault()

            if (!['input_text', 'dropdown', 'text', 'calculation'].includes(this.option_cell_selected)) {
                alert('해당 Cell에 해당하는 내용이 없습니다. 해당 Cell을 초기화 합니다.')
                _row = { ..._row, ...this.row_initial_property }
            } else {
                // 셀 초기화
                if (_row.placeholder) delete _row.placeholder[_col]
                if (_row.input_type) delete _row.input_type[_col]
                if (_row.dropdown) delete _row.dropdown[_col]
                if (_row.calculation) delete _row.calculation[_col]
                if (_row.noteditables) {
                    let idx = _row.noteditables.findIndex(item => item == _col)
                    if (idx > -1) _row.noteditables.splice(idx, 1)
                }
                if (_row.required_cells) {
                    let idx = _row.required_cells.findIndex(item => item == _col)
                    if (idx > -1) _row.required_cells.splice(idx, 1)
                }
            
                // 순차적으로 판단하여 저장 전 cell 상태변경을 각 셀 데이터에 반영
                if (this.option_cell_selected == 'input_text') {
                    // init
                    if (!_row['input_type']) _row['input_type'] = {}
                    if (!_row['placeholder']) _row['placeholder'] = {}

                    if (this.input_form.default_value) {
                        _row[_col] = this.input_form.default_value
                    }

                    if (this.input_form.type_value) {
                        _row['input_type'][_col] = this.input_form.type_value
                    }

                    if (this.input_form.placeholder) {
                        _row['placeholder'][_col] = this.input_form.placeholder
                    }
                } else if (this.option_cell_selected == 'dropdown') {
                    // init
                    if(!_row['dropdown']) _row['dropdown'] = {}

                    if (this.dropdown.text) {
                        _row['dropdown'][_col] = ih.stringToArray(this.dropdown.text)
                    }

                    if (this.dropdown.default_value) {
                        _row[_col] = this.dropdown.default_value
                    }
                } else if (this.option_cell_selected == 'text') {
                    if (!_row.noteditables) _row.noteditables = []
                    _row.noteditables.push(_col)
                    _row[_col] = this.noteditable_label
                } else if (this.option_cell_selected == 'calculation') {
                    if (!this.calculation.status) {
                        return false
                    }

                    if (!_row.calculation) _row.calculation = {}
                    _row.calculation[_col] = this.calculation.validated_str
                }

                // 필수 셀은 입력 폼·드롭다운 셀에만 저장한다 (noteditables/calculation 셀은 백엔드 판정 대상이 아님)
                if (this.required_cell && ['input_text', 'dropdown'].includes(this.option_cell_selected)) {
                    if (!_row.required_cells) _row.required_cells = []
                    _row.required_cells.push(_col)
                    // 필수 셀 지정은 문항 필수를 함의한다 — 자동이면 '켬' 으로 승격 (명시적 '끔' 은 존중)
                    this.submit_required = promoteSubmitRequiredForCell(this.submit_required)
                } 
            }

            this.$set(this.sub_data_contents.structure, row_index, _row)
            this.$nextTick( () => {
                this.$bvModal.hide(`table-cell-editor-${this.sub_code}`)
            })
        },
        initializeCellEditorOption () {
            this.input_form = {
                default_value: null,
                type_value: 'text',
                placeholder: null
            },
            
            this.dropdown = {
                text: null,
                options: null,
                default_value: null
            },

            this.noteditable_label = null,
            this.required_cell = false,

            this.calculation = {
                string: null,
                validated_str: null,
                status: null,
                status_message: null
            }

            this.option_cell_selected = ''
            this.editing_row_index = 0
            this.editing_col_index = 0
            this.editing_col_label = null
            this.editing_row = null
        },
        addNewTableRow () {
            const _new_table_row = { ...this.row_initial_property }
            this.table_header_col.forEach(_header => {
                _new_table_row[_header] = ''
            });

            this.sub_data_contents.structure.push(_new_table_row)
        },
        addDuplicatedRow (row_index) {
            let new_item = ih.deepCopy(this.sub_data_contents.structure[row_index])
            this.sub_data_contents.structure.splice(row_index, 0, new_item)
        },
        deleteRow(row_index){
            this.sub_data_contents.structure.splice(row_index, 1)
        },
        async handleSaveSub () {
            this.sub_data_contents['table_header'] = ih.stringToArray(this.table_header)

            // 한글 헤더를 변경한 뒤 영문/중문 헤더 컬럼이 어긋난 채로 저장되는 것을 막는다.
            // 영/중 헤더의 컬럼 키(key) 순서열이 한글 헤더와 정확히 일치하지 않으면 저장을 중단한다.
            // (영/중 헤더가 아직 없으면 통과 — 번역 전 신규 문항. label 만 다른 경우는 key 가 같으므로 통과.)
            if (!this.isTableHeaderTranslationConsistent()) {
                alert('표의 한글 헤더를 변경하셨습니다.\n"번역" 편집 화면에서 영문/중문 헤더도 동일하게 맞춰 수정한 뒤 다시 저장해 주세요.')
                return
            }

            await this.saveSub()
            this.$emit('click-save')

            this.initializeCellEditorOption()
        },
        isTableHeaderTranslationConsistent () {
            const _koHeader = this.sub_data_contents['table_header'] || []
            return ['table_header_ea', 'table_header_ca'].every(_langKey => {
                const _overlay = this.sub_data_contents[_langKey]
                // 아직 번역이 없으면(빈 배열/미존재) 검사 통과
                if (!Array.isArray(_overlay) || !_overlay.length) return true
                const _overlayKeys = _overlay.map(_h => (_h && typeof _h === 'object') ? _h.key : undefined)
                return JSON.stringify(_overlayKeys) === JSON.stringify(_koHeader)
            })
        }
    }
}
</script>
